<template>
	<a-modal :title="isUpdate ? '修改角色' : '新增角色'" :width="640" :visible="visible" :confirmLoading="false"
		:maskClosable="false" @ok="() => { $emit('ok') }" @cancel="() => { $emit('cancel') }" >
		<a-spin :spinning="loading">
			<a-form-model ref="roleForm" :model="form" :label-col="{span:6}" :wrapper-col="{span:12}"
				autoComplete="off">
				<a-form-model-item v-show="false" label="名称" prop="halfIds">
					<a-input v-model="form.halfIds" />
				</a-form-model-item>
				
				<a-form-model-item label="名称" prop="name" :rules="[
                    {required: true, message: '必填，不能为空', trigger: 'blur'},
                    {validator: isExistName}
                ]">
					<a-input v-model="form.name" />
				</a-form-model-item>
				<a-form-model-item label="功能" prop="funcIds" :rules="[
                    {required: true, message: '必填，不能为空', trigger: 'blur'}
                ]">
					<a-tree v-model="form.funcIds" :tree-data="treeData" :checkable="true"
						:checked-keys="form.funcIds" @check="onCheck"/>
				</a-form-model-item>
			</a-form-model>
		</a-spin>
	</a-modal>
</template>

<script>
	import {
		funcTree
	} from "@/api/system/func";
	import {
		roleNameIsExist
	} from '@/api/system/role'

	export default {
		props: {
			visible: {
				type: Boolean,
				required: true
			},
			loading: {
				type: Boolean,
				default: () => false
			}
		},
		data() {
			return {
				treeData: [],
				form: {
					id: 0,
					name: '',
					funcIds: [],
					halfIds:''
				}
			}
		},
		computed: {
			isUpdate: function() {
				return this.form.id > 0 ? true : false
			}
		},
		created() {
			this.fetchTreeData();
		},
		methods: {
			// 处理节点选中事件
			onCheck(checkedKeys, { halfCheckedKeys }) {
				if( halfCheckedKeys ) {
					this.form.halfIds = halfCheckedKeys.toString();
				}
			},
			initForm() {
				this.form = {
					id: 0,
					name: '',
					funcIds: [],
					halfIds:''
				};
			},
			fetchTreeData() {
				return funcTree().then(res => {
					this.treeData = res.data
				});
			},
			isExistName(rule, value, callback) {
				if (this.isUpdate && this.form.name == value) {
					callback();
				} else {
					roleNameIsExist(value).then(res => {
						if (res.data) {
							callback('角色名称已存在');
						} else {
							callback();
						}
					});
				}
			},
		}
	}
</script>